import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { OrderInfo, OrderInfoDelivery } from 'common/types';
import { RentalsTabValue, RentalsTabValues } from 'services/types';
import RentalCardDeliveryStatus from './RentalCardDeliveryStatus';
import RentalCardPaymentStatus from './RentalCardPaymentStatus';
import RentalCardPreparedStatus from './RentalCardPreparedStatus';
import RentalCardCommentStatus from './RentalCardCommentStatus';

interface Props {
	rentalInfo: OrderInfo;
	rentalTab: RentalsTabValue;
	delivery?: OrderInfoDelivery | undefined;
}
const RentalCardStatusBar = (props: Props) => {
	const { rentalInfo, rentalTab, delivery } = props;
	const classes = useStyles();

	const bookingHasComment = rentalInfo.bookingComment?.value || rentalInfo.additionalInformation;

	return (
		<div className={classes.statusContainer}>
			{rentalTab === RentalsTabValues.BOOKED && rentalInfo.prepared && <RentalCardPreparedStatus />}
			{delivery && <RentalCardDeliveryStatus delivery={delivery} rentalTab={rentalTab} />}
			{bookingHasComment && <RentalCardCommentStatus />}
			<RentalCardPaymentStatus rentalInfo={rentalInfo} />
		</div>
	);
};

const useStyles = makeStyles(() =>
	createStyles({
		statusContainer: {
			position: 'absolute',
			bottom: 0,
			right: 0,
			display: 'flex',
		},
	}),
);

export default RentalCardStatusBar;
